<template>
  <div class="main">
    <span style="width: 50px; vertical-align: middle;">
        <router-link :to="{ path: '/FieldworkRequest/' + fieldworkRequest.fieldworkRequestId }" tag="a" class="fa fa-edit" style="font-size: 16px;"></router-link>
    </span>

    <span>
        <span class="label">Request DBA No.</span>
        <span class="value">{{ fieldworkRequest.dbNumber }}</span>
    </span>
    <span>
        <span class="label">Field Org. Project No.</span>
        <span class="value">{{ fieldworkRequest.fieldOrganizationProjectNumber}}</span>
    </span>
  </div>
</template>
<script>

import loggingService from '../services/util/loggingService'

export default {
    name: 'fieldworkRequestHeader',
    data: function () {
        return {
            isDebug: false
        }
    },
    props: [ 'fieldworkRequest' ],
    created () {
        loggingService.log(this.isDebug, 'fieldworkRequestHeader', 'created')
    },
    mounted () {
        loggingService.log(this.isDebug, 'fieldworkRequestHeader', 'mounted')
    }
}
</script>

<style>
    .main {
        padding: 10px;
        margin-left: 10px;
        margin-right: 10px;
        margin-bottom: 10px;
        border: 1px solid #cccccc;
        border-radius: 4px;
        background-color: #f5f5f5;
    }
    .label {
        margin-right: 20px;
        color: #555555;
        font-weight: normal;
    }
    .value {
        margin-right: 20px;
        font-weight: bold;
    }
</style>



// WEBPACK FOOTER //
// FieldworkRequestHeader.vue?4bdb1aa2